<template>
  <div
    :class="$style.root"
    v-if="blocks?.length"
  >
    <template
      v-for="block in blocks"
      v-if="blocks"
      :key="block.id"
    >
      <CoreBlocksHeaderComponent
        v-if="block.__component === 'blocks.header' && block?.text"
        :text="block?.text"
        :class="$style.block"
      />

      <CoreBlocksImagesComponent
        v-else-if="block.__component === 'blocks.images' && block?.files?.data"
        :images="block?.files?.data"
        :richText="block?.richText"
        :class="$style.block"

      />

      <CoreBlocksLinksComponent
        v-else-if="block.__component === 'blocks.links' && block?.links"
        :label="block?.label"
        :links="block?.links"
        :class="$style.block"
      />

      <CoreBlocksNoteComponent
        v-else-if="block.__component === 'blocks.note' && block?.richText"
        :rich-text="block?.richText"
        :class="$style.block"
      />

      <CoreBlocksRichTextComponent
        v-else-if="block.__component === 'blocks.rich-text' && block?.richText"
        :rich-text="block?.richText"
        :class="$style.block"
      />

      <CoreBlocksSummaryListComponent
        v-else-if="block.__component === 'blocks.summary-list' && block?.summaries?.length"
        :label="block?.label"
        :summaries="block?.summaries"
        :class="$style.block"
      />

      <CoreBlocksListWithPopupComponent
        v-else-if="block?.__component === 'blocks.list-with-popup' && block?.listItems?.length"
        :items="block?.listItems"
        :blockId="block?.id"
        :label="block?.label"
        :class="$style.block"
      />

      <CoreBlocksDetailListComponent
        v-else-if="block.__component === 'blocks.detail-list' && block?.details?.length"
        :label="block?.label"
        :details="block?.details"
        :class="$style.block"
      />

      <CoreBlocksVideoComponent
        v-else-if="block.__component === 'blocks.video' && block?.video?.provider && block?.video?.providerUid"
        :provider="block?.video?.provider"
        :providerUid="block?.video?.providerUid"
        :class="$style.block"
      />

      <CoreBlocksSponsorsComponent
        v-else-if="block.__component === 'blocks.sponsors' && block?.sponsors?.data"
        :sponsors="block?.sponsors?.data"
        :class="$style.block"
      />

      <CoreBlocksDownloadsComponent
        v-else-if="block.__component === 'blocks.downloads' && block?.downloads"
        :rich-text="block?.richText"
        :downloads="block?.downloads"
        :class="$style.block"
      />

      <CoreBlocksStaffListComponent
        v-else-if="block.__component === 'blocks.staff-list' && block?.groups?.length"
        :groups="block?.groups"
        :label="block?.label"
        :class="$style.block"
      />

      <CoreBlocksCodeComponent
        v-else-if="block.__component === 'blocks.code' && block?.text"
        :text="block?.text"
        :class="$style.block"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  blocks: {
    type: Array
  }
})
</script>

<style module>
.root {
  composes: container from global;
}

.block {
  margin-top: var(--block--margin-top, 0px);
}

.block:not(:last-of-type) {
  margin-bottom: var(--block--margin-bottom, calc(var(--font-default--line-height, 1em) * 1));
}
</style>
